import { render } from "./XchNSpace.vue?vue&type=template&id=3f6be35a&scoped=true"
import script from "./XchNSpace.vue?vue&type=script&lang=js"
export * from "./XchNSpace.vue?vue&type=script&lang=js"

import "./XchNSpace.vue?vue&type=style&index=0&id=3f6be35a&scoped=true&lang=css"

import exportComponent from "/Users/fred/Downloads/learn_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6be35a"]])

export default __exports__